import ShortCutKey from '../../interaction/shortcutkey/index';
import Contextmenu from '../../interaction/contextmenu';

interface MouseClickPosition {
    left: number,
    top: number
};

function init(): void {
    ShortCutKey.on({
        keyName: 'mouseup+mouseright',
        callback: (event) => {
            let mouseClickPosition: ShowMenuParams = getMouseClickPosition(event);

            Contextmenu.show(mouseClickPosition);
        }
    });

    ShortCutKey.on({
        keyName: 'appToBackground',
        callback: (event) => {
            Contextmenu.hide();
        }
    });

    ShortCutKey.on({
        keyName: 'mousedown+outsideofstage',
        callback: (ev: JQuery.MouseDownEvent): void => {
            Contextmenu.hide();
        }
    });

    ShortCutKey.on({
        keyName: 'mouseup+mouseleft',
        callback: (event) => {
            Contextmenu.hide();
        }
    });
}

function getMouseClickPosition(ev): ShowMenuParams {
    let result: ShowMenuParams = {
        left: 0,
        top: 0
    };
    let $stage: JQuery<HTMLElement> = $('.shelvesbuild-e-sketchpad');
    let stagePosition: FreeObjMap = $stage.offset();

    result.left = ev.clientX - stagePosition.left;
    result.top = ev.clientY - stagePosition.top;

    return result;
}

export default {
    init
};
